import React from 'react';
import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import './PrdSwiper.css';

const GallerySwiper = ({ slides, onSlideClick }) => {

  const handleSlideClick = (dgIdx) => {
    onSlideClick(dgIdx);
  };

  return (
    <Swiper
      slidesPerView={5}
      initialSlide={0}
      centeredSlides={false}
      rewind={false}
      loop={false}
      autoplay={false} 
      navigation={true}
      modules={[Navigation]}
      className="mySwiper"
    >
      {slides.map((slide, index) => (
        <SwiperSlide key={index}>
          <a href="#" onClick={() => handleSlideClick(slide.dgIdx)}>
            <img src={slide.imgUrl} alt={`dgImg-${index + 1}`} />
          </a>
        </SwiperSlide>
      ))}
    </Swiper>
  );
}

export default GallerySwiper;
